import styled from "styled-components";

import Adder from "./Adder";
import Mapping from "./Mapping";
import Box from "../../../components/Box";
import useRevitValues from "../useRevitValues";

const Styled = styled(Box)`
    align-items: center;
    display: grid;
    font-family: var(--font-mono);
    font-size: 1rem;
    gap: 0 32px;
    grid-template-columns: repeat(4, min-content);
    grid-auto-rows: min-content;

    & > button {
        align-self: flex-start;
        grid-column: 1 / 3;
        margin-top: 8px;
    }
`;

export default function Editor(props) {
    const { bimClassID, parameterID } = props;

    const revitValues = useRevitValues();

    return (
        <Styled name="value mapping">
            {
                revitValues.data
                    ? revitValues
                        .data
                        .revitValues
                        .filter(
                            (revitValue) => [
                                revitValue.parameterID === parameterID,
                                revitValue.bimClassID === bimClassID,
                            ].every(Boolean)
                        )
                        .map(
                            (revitValue) => <Mapping key={ revitValue.value } { ...revitValue } />
                        )
                    : "loading"
            }
            <Adder { ...props } />
        </Styled>
    );
}
